var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiamiHackWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 277,
    viewBox: "0 0 527 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.774 27.5394C94.8715 36.5864 74.8497 50.0826 63.4298 57.7947C43.8529 70.6977 39.4036 73.5156 19.9749 84.3422C15.229 86.8635 12.7078 89.0881 13.5976 89.8297C15.9706 91.1645 37.6238 87.605 49.192 83.749C54.5312 81.9692 64.9129 77.9649 72.1801 74.8503C79.4473 71.5875 85.6763 69.0663 85.9729 69.0663C86.2695 69.0663 86.4178 70.4011 86.4178 72.0325C86.4178 74.702 83.6 80.4861 80.0405 84.6388C79.299 85.3804 74.7014 92.9442 69.6588 101.25C61.6501 114.301 47.5606 137.289 34.361 158.497C32.2847 161.908 26.9455 170.362 22.6445 177.333C18.3435 184.303 13.4493 192.164 11.8179 194.833L9 199.727L38.2171 198.838L47.4123 182.523C64.468 152.417 70.9936 143.073 89.829 122.013C109.406 100.063 145.742 73.3673 145.742 80.9311C145.742 82.7108 113.41 146.187 111.482 148.412C109.703 150.192 109.703 156.569 111.482 156.569C112.224 156.569 123.495 144.111 136.547 128.687C170.658 88.7915 187.12 72.774 190.383 76.0368C192.163 77.8166 190.68 81.376 173.179 117.267C148.708 167.692 147.225 171.104 147.225 174.96C147.225 178.667 147.522 178.816 157.31 178.816H167.247L176.739 153.158C191.421 113.559 200.765 91.1645 213.965 64.617C220.638 51.1207 225.978 39.8492 225.681 39.4043C225.384 38.9593 242.885 8.85224 236.952 9.00055L203.434 39.4043L190.087 51.5657C171.844 68.3247 169.175 68.473 175.404 52.6038C178.667 44.4468 178.518 40.8874 174.811 40.8874C173.624 40.8874 162.501 48.0062 150.191 56.7565C114.004 82.5625 101.249 91.3128 99.7658 91.3128C96.058 91.3128 99.7658 84.7871 119.788 54.9768C140.254 24.4249 142.627 19.9756 140.106 16.2679C139.216 14.7848 133.432 11.2253 132.097 11.2253C131.652 11.2253 120.826 18.6408 107.774 27.5394Z",
    fill: "url(#paint0_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 27.5394C94.8715 36.5864 74.8497 50.0826 63.4298 57.7947C43.8529 70.6977 39.4036 73.5156 19.9749 84.3422C15.229 86.8635 12.7078 89.0881 13.5976 89.8297C15.9706 91.1645 37.6238 87.605 49.192 83.749C54.5312 81.9692 64.9129 77.9649 72.1801 74.8503C79.4473 71.5875 85.6763 69.0663 85.9729 69.0663C86.2695 69.0663 86.4178 70.4011 86.4178 72.0325C86.4178 74.702 83.6 80.4861 80.0405 84.6388C79.299 85.3804 74.7014 92.9442 69.6588 101.25C61.6501 114.301 47.5606 137.289 34.361 158.497C32.2847 161.908 26.9455 170.362 22.6445 177.333C18.3435 184.303 13.4493 192.164 11.8179 194.833L9 199.727L38.2171 198.838L47.4123 182.523C64.468 152.417 70.9936 143.073 89.829 122.013C109.406 100.063 145.742 73.3673 145.742 80.9311C145.742 82.7108 113.41 146.187 111.482 148.412C109.703 150.192 109.703 156.569 111.482 156.569C112.224 156.569 123.495 144.111 136.547 128.687C170.658 88.7915 187.12 72.774 190.383 76.0368C192.163 77.8166 190.68 81.376 173.179 117.267C148.708 167.692 147.225 171.104 147.225 174.96C147.225 178.667 147.522 178.816 157.31 178.816H167.247L176.739 153.158C191.421 113.559 200.765 91.1645 213.965 64.617C220.638 51.1207 225.978 39.8492 225.681 39.4043C225.384 38.9593 242.885 8.85224 236.952 9.00055L203.434 39.4043L190.087 51.5657C171.844 68.3247 169.175 68.473 175.404 52.6038C178.667 44.4468 178.518 40.8874 174.811 40.8874C173.624 40.8874 162.501 48.0062 150.191 56.7565C114.004 82.5625 101.249 91.3128 99.7658 91.3128C96.058 91.3128 99.7658 84.7871 119.788 54.9768C140.254 24.4249 142.627 19.9756 140.106 16.2679C139.216 14.7848 133.432 11.2253 132.097 11.2253C131.652 11.2253 120.826 18.6408 107.774 27.5394Z",
    fill: "url(#paint1_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.872 19.6789C497.978 25.1664 491.304 37.1795 491.304 40.294C491.304 44.1501 493.38 45.0399 499.016 44.0017C503.91 42.9636 518 25.463 518 20.4204C518 17.6026 517.258 17.1576 511.623 17.1576C507.322 17.1576 504.355 18.0475 502.872 19.6789Z",
    fill: "url(#paint2_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.872 19.6789C497.978 25.1664 491.304 37.1795 491.304 40.294C491.304 44.1501 493.38 45.0399 499.016 44.0017C503.91 42.9636 518 25.463 518 20.4204C518 17.6026 517.258 17.1576 511.623 17.1576C507.322 17.1576 504.355 18.0475 502.872 19.6789Z",
    fill: "url(#paint3_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.52 55.4217C483.889 57.7947 480.181 64.3203 477.215 69.8078C473.21 77.5199 472.469 80.3378 473.804 81.2277C475.287 82.1175 475.138 82.4141 473.21 82.4141C470.392 82.4141 466.091 91.0161 458.083 112.373C451.705 129.725 451.409 133.729 456.451 136.102C461.346 138.327 466.091 135.064 489.079 114.004C509.398 95.4654 515.034 89.3847 515.034 86.1219C515.034 81.5243 509.695 84.1939 501.686 92.6475C492.787 101.991 484.927 106.885 481.367 105.551C478.105 104.216 479.439 100.36 491.156 78.8547C496.94 68.473 501.983 58.6845 502.427 57.0531C503.466 53.9386 502.724 53.4937 493.974 52.0106C489.228 51.269 488.19 51.714 485.52 55.4217Z",
    fill: "url(#paint4_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.52 55.4217C483.889 57.7947 480.181 64.3203 477.215 69.8078C473.21 77.5199 472.469 80.3378 473.804 81.2277C475.287 82.1175 475.138 82.4141 473.21 82.4141C470.392 82.4141 466.091 91.0161 458.083 112.373C451.705 129.725 451.409 133.729 456.451 136.102C461.346 138.327 466.091 135.064 489.079 114.004C509.398 95.4654 515.034 89.3847 515.034 86.1219C515.034 81.5243 509.695 84.1939 501.686 92.6475C492.787 101.991 484.927 106.885 481.367 105.551C478.105 104.216 479.439 100.36 491.156 78.8547C496.94 68.473 501.983 58.6845 502.427 57.0531C503.466 53.9386 502.724 53.4937 493.974 52.0106C489.228 51.269 488.19 51.714 485.52 55.4217Z",
    fill: "url(#paint5_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.262 63.5788C242.143 75.5919 241.55 77.2233 244.22 79.2996C249.114 83.4523 257.271 76.7784 267.949 60.0193C271.064 55.1251 269.877 54.2352 261.572 54.2352C254.75 54.2352 254.75 54.3835 249.262 63.5788Z",
    fill: "url(#paint6_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.262 63.5788C242.143 75.5919 241.55 77.2233 244.22 79.2996C249.114 83.4523 257.271 76.7784 267.949 60.0193C271.064 55.1251 269.877 54.2352 261.572 54.2352C254.75 54.2352 254.75 54.3835 249.262 63.5788Z",
    fill: "url(#paint7_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.879 72.1807C423.23 92.9441 421.895 94.2789 420.116 94.2789C417.149 94.2789 418.484 89.3847 426.196 70.1044C427.828 66.2483 428.718 62.3922 428.273 61.6507C427.828 60.7608 424.862 60.1676 421.747 60.1676C416.408 60.1676 415.221 61.2058 404.395 73.0706C391.047 87.9016 390.157 88.6431 388.526 87.0117C387.487 85.9735 392.085 73.5155 396.534 65.6551C398.314 62.3922 395.941 58.6845 391.937 58.6845C388.377 58.6845 385.559 62.3922 380.072 74.1087C374.288 86.7151 359.902 101.546 341.215 113.856C329.053 122.161 323.714 124.238 323.714 120.826C323.714 119.937 328.757 109.555 334.837 97.5417C341.066 85.6769 345.664 74.9986 345.219 73.8121C344.774 72.4773 342.401 72.0324 337.507 72.329L330.388 72.7739L323.714 84.7871C320.006 91.461 313.332 100.953 308.883 105.699C304.434 110.593 299.688 115.932 298.353 117.415C296.128 120.085 280.408 134.174 275.217 138.179C271.509 140.848 266.318 140.7 265.28 137.882C262.759 131.505 285.005 97.8383 301.023 83.4523C307.697 77.5199 309.921 76.4817 314.964 76.4817C319.858 76.4817 320.896 76.0368 320.451 73.8121C320.155 71.8841 318.227 71.1425 312.443 70.8459C297.018 69.956 279.814 83.4523 262.165 110.296C252.525 124.979 241.847 135.806 231.465 141.145C222.418 145.891 224.94 138.327 245.406 100.508C249.411 93.0924 248.076 91.3127 238.881 91.3127C233.987 91.3127 233.097 92.0543 228.944 98.7282C215.744 120.233 196.612 165.913 198.392 171.548C198.985 173.18 200.913 174.811 202.99 175.256C205.956 175.998 208.774 174.515 217.376 167.989C223.308 163.391 231.317 156.421 235.47 152.268C239.474 148.115 243.33 144.704 243.923 144.704C244.517 144.704 246 147.077 247.186 149.895C249.114 154.344 250.004 155.086 254.602 155.086C260.682 155.086 276.403 145.001 291.531 131.356C303.396 120.53 305.175 121.716 300.281 137.141C298.501 142.628 297.018 148.56 297.018 150.34C297.018 153.306 300.874 156.569 304.137 156.569C306.065 156.569 324.011 141.441 341.956 124.831C349.965 117.415 357.084 111.038 357.825 110.89C361.088 109.703 358.864 116.822 351.151 132.543C342.401 150.488 341.511 153.455 345.664 153.751C352.635 154.196 356.491 151.527 360.94 143.073C363.461 138.03 388.229 109.11 393.42 105.106C398.611 101.101 397.721 106.885 390.602 123.348C386.301 132.84 383.186 141.59 383.631 142.776C384.076 143.814 386.449 144.704 388.971 144.704C392.53 144.704 394.903 143.37 398.462 139.069C421.599 112.818 426.493 107.627 428.421 107.627C431.239 107.627 431.239 107.33 424.565 123.199C417.149 140.552 417.149 141.738 423.823 141.738C432.722 141.738 432.87 141.441 453.485 88.0499C459.714 71.8841 464.46 58.0912 463.867 57.2014C463.422 56.4598 461.198 55.7183 458.973 55.7183C455.71 55.7183 452.299 58.8328 440.879 72.1807Z",
    fill: "url(#paint8_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.879 72.1807C423.23 92.9441 421.895 94.2789 420.116 94.2789C417.149 94.2789 418.484 89.3847 426.196 70.1044C427.828 66.2483 428.718 62.3922 428.273 61.6507C427.828 60.7608 424.862 60.1676 421.747 60.1676C416.408 60.1676 415.221 61.2058 404.395 73.0706C391.047 87.9016 390.157 88.6431 388.526 87.0117C387.487 85.9735 392.085 73.5155 396.534 65.6551C398.314 62.3922 395.941 58.6845 391.937 58.6845C388.377 58.6845 385.559 62.3922 380.072 74.1087C374.288 86.7151 359.902 101.546 341.215 113.856C329.053 122.161 323.714 124.238 323.714 120.826C323.714 119.937 328.757 109.555 334.837 97.5417C341.066 85.6769 345.664 74.9986 345.219 73.8121C344.774 72.4773 342.401 72.0324 337.507 72.329L330.388 72.7739L323.714 84.7871C320.006 91.461 313.332 100.953 308.883 105.699C304.434 110.593 299.688 115.932 298.353 117.415C296.128 120.085 280.408 134.174 275.217 138.179C271.509 140.848 266.318 140.7 265.28 137.882C262.759 131.505 285.005 97.8383 301.023 83.4523C307.697 77.5199 309.921 76.4817 314.964 76.4817C319.858 76.4817 320.896 76.0368 320.451 73.8121C320.155 71.8841 318.227 71.1425 312.443 70.8459C297.018 69.956 279.814 83.4523 262.165 110.296C252.525 124.979 241.847 135.806 231.465 141.145C222.418 145.891 224.94 138.327 245.406 100.508C249.411 93.0924 248.076 91.3127 238.881 91.3127C233.987 91.3127 233.097 92.0543 228.944 98.7282C215.744 120.233 196.612 165.913 198.392 171.548C198.985 173.18 200.913 174.811 202.99 175.256C205.956 175.998 208.774 174.515 217.376 167.989C223.308 163.391 231.317 156.421 235.47 152.268C239.474 148.115 243.33 144.704 243.923 144.704C244.517 144.704 246 147.077 247.186 149.895C249.114 154.344 250.004 155.086 254.602 155.086C260.682 155.086 276.403 145.001 291.531 131.356C303.396 120.53 305.175 121.716 300.281 137.141C298.501 142.628 297.018 148.56 297.018 150.34C297.018 153.306 300.874 156.569 304.137 156.569C306.065 156.569 324.011 141.441 341.956 124.831C349.965 117.415 357.084 111.038 357.825 110.89C361.088 109.703 358.864 116.822 351.151 132.543C342.401 150.488 341.511 153.455 345.664 153.751C352.635 154.196 356.491 151.527 360.94 143.073C363.461 138.03 388.229 109.11 393.42 105.106C398.611 101.101 397.721 106.885 390.602 123.348C386.301 132.84 383.186 141.59 383.631 142.776C384.076 143.814 386.449 144.704 388.971 144.704C392.53 144.704 394.903 143.37 398.462 139.069C421.599 112.818 426.493 107.627 428.421 107.627C431.239 107.627 431.239 107.33 424.565 123.199C417.149 140.552 417.149 141.738 423.823 141.738C432.722 141.738 432.87 141.441 453.485 88.0499C459.714 71.8841 464.46 58.0912 463.867 57.2014C463.422 56.4598 461.198 55.7183 458.973 55.7183C455.71 55.7183 452.299 58.8328 440.879 72.1807Z",
    fill: "url(#paint9_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.541 186.231C455.561 198.096 454.078 197.948 458.083 185.045C458.973 181.93 458.676 181.633 455.71 182.078C452.892 182.375 451.26 185.638 445.18 201.655C441.175 212.185 438.358 221.381 438.802 221.974C440.434 224.643 443.993 221.084 446.96 214.262C448.739 210.257 450.667 206.994 451.26 206.994C452.002 206.994 455.265 210.109 458.528 213.965C463.57 220.046 464.905 220.787 467.13 219.453C471.282 216.931 471.134 213.224 466.981 207.143C464.905 204.177 463.125 200.914 463.125 199.876C463.125 198.986 467.871 194.388 473.507 189.791C482.554 182.523 486.41 177.332 482.851 177.332C482.109 177.332 476.622 181.337 470.541 186.231Z",
    fill: "url(#paint10_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.541 186.231C455.561 198.096 454.078 197.948 458.083 185.045C458.973 181.93 458.676 181.633 455.71 182.078C452.892 182.375 451.26 185.638 445.18 201.655C441.175 212.185 438.358 221.381 438.802 221.974C440.434 224.643 443.993 221.084 446.96 214.262C448.739 210.257 450.667 206.994 451.26 206.994C452.002 206.994 455.265 210.109 458.528 213.965C463.57 220.046 464.905 220.787 467.13 219.453C471.282 216.931 471.134 213.224 466.981 207.143C464.905 204.177 463.125 200.914 463.125 199.876C463.125 198.986 467.871 194.388 473.507 189.791C482.554 182.523 486.41 177.332 482.851 177.332C482.109 177.332 476.622 181.337 470.541 186.231Z",
    fill: "url(#paint11_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.369 185.786C411.662 186.083 407.806 187.121 407.064 188.159C405.284 190.236 391.936 224.347 391.936 226.572C391.936 228.351 410.772 226.868 416.556 224.792C422.637 222.419 420.56 220.342 412.107 220.342C407.657 220.342 403.505 219.601 403.06 218.859C400.242 214.41 407.212 208.478 415.369 208.478C419.225 208.329 424.565 205.511 424.565 203.435C424.565 202.99 421.302 202.545 417.149 202.545C410.327 202.545 409.734 202.249 409.734 198.986C409.734 194.24 412.403 192.312 421.005 191.274C429.014 190.236 433.463 188.308 433.463 186.231C433.463 184.748 429.607 184.748 415.369 185.786Z",
    fill: "url(#paint12_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.369 185.786C411.662 186.083 407.806 187.121 407.064 188.159C405.284 190.236 391.936 224.347 391.936 226.572C391.936 228.351 410.772 226.868 416.556 224.792C422.637 222.419 420.56 220.342 412.107 220.342C407.657 220.342 403.505 219.601 403.06 218.859C400.242 214.41 407.212 208.478 415.369 208.478C419.225 208.329 424.565 205.511 424.565 203.435C424.565 202.99 421.302 202.545 417.149 202.545C410.327 202.545 409.734 202.249 409.734 198.986C409.734 194.24 412.403 192.312 421.005 191.274C429.014 190.236 433.463 188.308 433.463 186.231C433.463 184.748 429.607 184.748 415.369 185.786Z",
    fill: "url(#paint13_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.876 191.422C364.499 192.312 359.012 193.35 358.715 193.795C357.677 194.833 344.477 230.427 344.477 232.207C344.477 233.987 363.461 232.8 369.393 230.576C375.919 228.054 373.101 225.385 364.203 225.533C356.045 225.533 355.601 225.385 355.601 221.825C355.601 217.821 359.308 215.448 368.948 213.372C377.105 211.74 377.995 207.439 369.987 208.181C366.131 208.626 363.758 208.033 362.423 206.401C359.457 202.99 366.427 196.613 373.249 196.613C382.148 196.613 389.712 192.312 384.224 190.384C383.186 190.087 377.105 190.532 370.876 191.422Z",
    fill: "url(#paint14_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.876 191.422C364.499 192.312 359.012 193.35 358.715 193.795C357.677 194.833 344.477 230.427 344.477 232.207C344.477 233.987 363.461 232.8 369.393 230.576C375.919 228.054 373.101 225.385 364.203 225.533C356.045 225.533 355.601 225.385 355.601 221.825C355.601 217.821 359.308 215.448 368.948 213.372C377.105 211.74 377.995 207.439 369.987 208.181C366.131 208.626 363.758 208.033 362.423 206.401C359.457 202.99 366.427 196.613 373.249 196.613C382.148 196.613 389.712 192.312 384.224 190.384C383.186 190.087 377.105 190.532 370.876 191.422Z",
    fill: "url(#paint15_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.651 206.253C326.977 219.749 324.455 220.787 325.79 209.367C327.273 196.613 324.307 196.909 315.853 210.109C307.4 223.605 305.027 222.715 309.624 207.588C311.701 200.617 311.108 197.206 308.141 199.282C306.51 200.469 302.654 211.74 299.243 225.533C298.056 230.427 296.573 235.47 296.128 236.953C295.535 238.881 296.128 239.623 298.353 239.623C301.467 239.623 306.658 233.394 312.146 223.457C316.298 215.893 318.375 217.524 317.188 227.61C315.26 244.814 321.638 239.919 334.096 214.707C338.99 204.77 342.994 196.168 342.994 195.871C342.994 195.426 342.104 195.13 341.066 195.13C340.028 195.13 336.765 200.172 333.651 206.253Z",
    fill: "url(#paint16_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.651 206.253C326.977 219.749 324.455 220.787 325.79 209.367C327.273 196.613 324.307 196.909 315.853 210.109C307.4 223.605 305.027 222.715 309.624 207.588C311.701 200.617 311.108 197.206 308.141 199.282C306.51 200.469 302.654 211.74 299.243 225.533C298.056 230.427 296.573 235.47 296.128 236.953C295.535 238.881 296.128 239.623 298.353 239.623C301.467 239.623 306.658 233.394 312.146 223.457C316.298 215.893 318.375 217.524 317.188 227.61C315.26 244.814 321.638 239.919 334.096 214.707C338.99 204.77 342.994 196.168 342.994 195.871C342.994 195.426 342.104 195.13 341.066 195.13C340.028 195.13 336.765 200.172 333.651 206.253Z",
    fill: "url(#paint17_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.397 210.702C224.939 220.787 219.897 223.902 218.265 222.27C217.376 221.381 217.376 219.453 218.414 216.783C219.155 214.558 219.897 212.037 219.897 211.295C219.897 208.774 215.596 209.961 213.816 213.075C211.74 216.931 200.617 247.038 200.617 248.67C200.617 249.411 201.803 250.004 203.286 250.004C205.066 250.004 206.697 248.076 207.884 244.369C210.108 238.288 212.185 235.173 214.113 235.173C214.706 235.173 217.376 238.14 219.897 241.847C224.939 249.263 227.016 250.004 231.02 245.555C233.541 242.737 233.393 242.441 228.944 235.767C224.494 228.944 224.494 228.648 227.016 225.682C228.351 223.902 230.427 221.974 231.317 221.381C232.355 220.787 236.359 217.376 240.067 213.817C248.669 205.956 246.593 203.435 237.397 210.702Z",
    fill: "url(#paint18_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.397 210.702C224.939 220.787 219.897 223.902 218.265 222.27C217.376 221.381 217.376 219.453 218.414 216.783C219.155 214.558 219.897 212.037 219.897 211.295C219.897 208.774 215.596 209.961 213.816 213.075C211.74 216.931 200.617 247.038 200.617 248.67C200.617 249.411 201.803 250.004 203.286 250.004C205.066 250.004 206.697 248.076 207.884 244.369C210.108 238.288 212.185 235.173 214.113 235.173C214.706 235.173 217.376 238.14 219.897 241.847C224.939 249.263 227.016 250.004 231.02 245.555C233.541 242.737 233.393 242.441 228.944 235.767C224.494 228.944 224.494 228.648 227.016 225.682C228.351 223.902 230.427 221.974 231.317 221.381C232.355 220.787 236.359 217.376 240.067 213.817C248.669 205.956 246.593 203.435 237.397 210.702Z",
    fill: "url(#paint19_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.628 215.745C167.692 220.194 156.272 235.915 156.123 245.259C156.123 254.454 163.836 258.013 174.217 253.267C180.743 250.449 185.489 246.148 183.857 244.517C183.264 244.072 181.188 244.814 179.112 246.148C174.514 249.115 168.137 248.818 166.06 245.407C163.539 241.403 166.357 232.356 171.844 226.275C177.48 220.194 181.633 218.711 186.824 220.936C189.493 221.974 190.976 221.677 193.349 219.453C196.167 216.931 196.167 216.635 193.794 214.855C190.235 212.185 184.599 212.482 177.628 215.745Z",
    fill: "url(#paint20_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.628 215.745C167.692 220.194 156.272 235.915 156.123 245.259C156.123 254.454 163.836 258.013 174.217 253.267C180.743 250.449 185.489 246.148 183.857 244.517C183.264 244.072 181.188 244.814 179.112 246.148C174.514 249.115 168.137 248.818 166.06 245.407C163.539 241.403 166.357 232.356 171.844 226.275C177.48 220.194 181.633 218.711 186.824 220.936C189.493 221.974 190.976 221.677 193.349 219.453C196.167 216.931 196.167 216.635 193.794 214.855C190.235 212.185 184.599 212.482 177.628 215.745Z",
    fill: "url(#paint21_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.466 221.826C128.39 223.605 121.123 233.097 114.597 243.034C104.957 257.568 103.177 261.276 105.253 261.721C106.588 262.018 109.406 260.238 111.482 257.717C114.004 254.899 117.266 252.971 120.974 252.378C125.868 251.488 126.61 251.784 128.241 255.195C129.28 257.568 131.059 258.903 133.284 258.903C136.398 258.903 136.695 258.013 137.733 245.852C140.106 218.414 139.068 215.003 130.466 221.826ZM130.911 238.881C130.911 242.441 130.021 244.517 128.093 245.555C125.424 246.89 120.529 246.297 120.529 244.517C120.529 243.182 123.94 237.398 126.165 234.877C129.131 231.317 130.911 232.801 130.911 238.881Z",
    fill: "url(#paint22_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.466 221.826C128.39 223.605 121.123 233.097 114.597 243.034C104.957 257.568 103.177 261.276 105.253 261.721C106.588 262.018 109.406 260.238 111.482 257.717C114.004 254.899 117.266 252.971 120.974 252.378C125.868 251.488 126.61 251.784 128.241 255.195C129.28 257.568 131.059 258.903 133.284 258.903C136.398 258.903 136.695 258.013 137.733 245.852C140.106 218.414 139.068 215.003 130.466 221.826ZM130.911 238.881C130.911 242.441 130.021 244.517 128.093 245.555C125.424 246.89 120.529 246.297 120.529 244.517C120.529 243.182 123.94 237.398 126.165 234.877C129.131 231.317 130.911 232.801 130.911 238.881Z",
    fill: "url(#paint23_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3926 224.495C96.5028 225.088 95.0197 227.906 93.9815 230.872C91.7569 237.695 88.1974 240.958 81.6718 241.996C75.1461 243.182 72.3283 240.216 74.5529 234.58C76.7775 228.499 76.4809 226.423 73.3664 227.313C71.5867 227.758 69.2137 231.317 67.2857 236.36C65.3577 240.958 62.5398 248.076 60.9084 252.229C59.1287 256.233 57.3489 261.573 56.6074 263.797C55.5692 267.505 55.7175 267.95 58.6837 267.505C60.9084 267.208 62.5398 265.132 64.1712 260.831C67.5823 251.784 70.9935 248.521 77.8157 248.521C84.638 248.521 86.2694 251.043 83.5998 258.458C82.5616 261.276 81.9684 263.946 82.4133 264.391C83.7481 265.577 89.3839 263.352 89.3839 261.573C89.3839 260.683 92.3501 252.081 96.0579 242.441C99.7656 232.8 102.732 224.495 102.732 224.05C102.732 223.012 99.3207 223.16 97.3926 224.495Z",
    fill: "url(#paint24_linear_18_887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3926 224.495C96.5028 225.088 95.0197 227.906 93.9815 230.872C91.7569 237.695 88.1974 240.958 81.6718 241.996C75.1461 243.182 72.3283 240.216 74.5529 234.58C76.7775 228.499 76.4809 226.423 73.3664 227.313C71.5867 227.758 69.2137 231.317 67.2857 236.36C65.3577 240.958 62.5398 248.076 60.9084 252.229C59.1287 256.233 57.3489 261.573 56.6074 263.797C55.5692 267.505 55.7175 267.95 58.6837 267.505C60.9084 267.208 62.5398 265.132 64.1712 260.831C67.5823 251.784 70.9935 248.521 77.8157 248.521C84.638 248.521 86.2694 251.043 83.5998 258.458C82.5616 261.276 81.9684 263.946 82.4133 264.391C83.7481 265.577 89.3839 263.352 89.3839 261.573C89.3839 260.683 92.3501 252.081 96.0579 242.441C99.7656 232.8 102.732 224.495 102.732 224.05C102.732 223.012 99.3207 223.16 97.3926 224.495Z",
    fill: "url(#paint25_linear_18_887)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_887",
    x: 0,
    y: 0,
    width: 527,
    height: 276.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.00392157 0 0 0 0 0.376471 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_887",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_18_887",
    x1: 18,
    y1: 268,
    x2: 558.965,
    y2: 342.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D03880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_18_887",
    x1: 6.49997,
    y1: 189.646,
    x2: 336.049,
    y2: -41.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571308,
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#550060"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiamiHackWeek);
export default __webpack_public_path__ + "static/media/miami-hack-week.d8cabcfa78d21965979139776a7609b7.svg";
export { ForwardRef as ReactComponent };